import { Protocol } from '@orbital/games-frontend-library'
import { useState } from 'react'

export let settings: any = {
    firstStake: "0.1",
    secondStake: "0.1",
    numOfBets: "0",
    cashoutAt: "0",
    audio: {
        sound: '50',
        music: '50',
        isMusicOff: false,
        isSoundOff: false,
    },
}
let setsettings: any
let globalSocketMessages: any


export const useSettings = (func: any) => {
    return (
        ([settings, setsettings] = useState<any>(settings)),
        (globalSocketMessages = func)
    )
}

export const setAudios = (audio: any) => setsettings({ ...settings, audio })


export const sendStakes = (stakes: any, settings: any) => {
    globalSocketMessages.settingsPost({ audio: settings, stakes: stakes })
}

export const sendAudio = (audio: any, stakes: any) => {
    globalSocketMessages.settingsPost({ stakes, audio })
}

// export function objectToString(stake: any, audio: any, autoConfigs: any) {
//     let str = ''
//     if (stake === '') {
//         str += '0.10;'
//     }
//     else {
//         str += stake + ";"
//     }
//     const audioString = Object.values(audio).join(';')
//     str += audioString + ";"
//     const autoString = Object.values(autoConfigs).join(';')
//     str += autoString + ";"
//     return str
// }